import React from "react"
import { Menu, Checkbox, Button } from "antd"
import commonStrings from "../../commonStrings"

const fileTypeOptions = ["All", "PDF", "Video", "Image", "Document", "YouTube", "GIF", "Spreadsheet"]

const FileTypeMenu = ({ selectedFileTypes, setSelectedFileTypes }) => {
  const handleCheckboxChange = (type) => {
    if (type === "All") {
      setSelectedFileTypes(["All"])
    } else {
      const updatedSelection = selectedFileTypes.includes(type)
        ? selectedFileTypes.filter((item) => item !== type)
        : [...selectedFileTypes.filter((item) => item !== "All"), type]

      setSelectedFileTypes(updatedSelection.length === 0 ? ["All"] : updatedSelection)
    }
  }

  const handleClearAll = () => {
    setSelectedFileTypes(["All"])
  }

  return (
    <Menu>
      <Menu.Item key="clear-all">
        <Button
          className="reset-filter-resources"
          type="link"
          onClick={handleClearAll}
          disabled={selectedFileTypes.length === 1 && selectedFileTypes.includes("All")}
        >
          {commonStrings.clearAll}
        </Button>
      </Menu.Item>

      {fileTypeOptions.map((type) => (
        <Menu.Item key={type}>
          <Checkbox
            className="overall-resources-checkbox"
            checked={selectedFileTypes.includes(type)}
            onChange={() => handleCheckboxChange(type)}
          >
            {type}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  )
}

export default FileTypeMenu
